import styles from "../../asset/styles/login/login.module.scss";
import InputText from "../inputText/inputText";
import IconsColor from "../../util/iconsColor";
import Button from "../button/button";
import React, {useState} from "react";
import {IFormErrors, TLoginActionType} from "../../pages/login/login";
import {ILoginApiPayload} from "../../models/axiosModel";
import logo from "../../asset/images/logo.png";

export const LoginFooter = () => {
    const copyRightYear = new Date().getFullYear();

    return (
        <div className={styles.loginTerms}>
            <p>© {copyRightYear} Travel Advocates. All rights reserved.</p>
            <div className={styles.termsLinks}>
                <a href="#privacy">Privacy Policy</a>
                <span>•</span>
                <a href="#terms">Terms of Service</a>
            </div>
        </div>
    )
}

interface ILoginCardProps {
    activeTab: TLoginActionType;
    handleTabChange: (tab: TLoginActionType) => void;
    handleSubmit: () => Promise<void>;
    formData: ILoginApiPayload;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    errors: IFormErrors;
    handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LoginCard = (props: ILoginCardProps) => {
    const {
        activeTab,
        handleTabChange,
        handleSubmit,
        formData,
        handleInputChange,
        errors,
        handlePhoneChange
    } = props;

    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <div className={styles.loginCard}>
            <div className={styles.loginHeader}>
                <h2>Sign In</h2>
                <p>Enter your credentials to access your account</p>
            </div>

            <div className={styles.loginTabs}>
                <button
                    type="button"
                    className={`${styles.loginTab} ${activeTab === 'email' ? styles.loginTabActive : ''}`}
                    onClick={() => handleTabChange('email')}
                >
                    Email
                </button>
                <button
                    type="button"
                    className={`${styles.loginTab} ${activeTab === 'phone' ? styles.loginTabActive : ''}`}
                    onClick={() => handleTabChange('phone')}
                >
                    Phone
                </button>
            </div>

            <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }} className={styles.loginForm}>
                {activeTab === 'email' ? (
                    <InputText
                        label="Email Address"
                        value={formData.user_email || ''}
                        onChange={handleInputChange}
                        placeholder="Enter your email"
                        type="email"
                        name="user_email"
                        id="user_email"
                        autoComplete="email"
                        error={errors.user_email}
                        leftIcon={
                            <IconsColor
                                iconName="mailIcon"
                                width="20px"
                                height="20px"
                                fillColor="none"
                                strokeColor="currentColor"
                            />
                        }
                    />
                ) : (
                    <InputText
                        label="Phone Number"
                        value={formData.user_mobile_number || ''}
                        onChange={handlePhoneChange}
                        placeholder="Enter your 10 digit phone number"
                        type="tel"
                        name="user_mobile_number"
                        id="user_mobile_number"
                        autoComplete="tel"
                        error={errors.user_mobile_number}
                        maxLength={10}
                        leftIcon={
                            <IconsColor
                                iconName="phoneIcon"
                                width="20px"
                                height="20px"
                                fillColor="none"
                                strokeColor="currentColor"
                            />
                        }
                    />
                )}
                <div className={styles.passwordIcon}>
                    <InputText
                        label="Password"
                        value={formData.user_password}
                        onChange={handleInputChange}
                        placeholder="Enter your password"
                        type={showPassword ? "text" : "password"}
                        name="user_password"
                        id="user_password"
                        autoComplete="current-password"
                        error={errors.user_password}
                        leftIcon={
                            <IconsColor
                                iconName="passwordIcon"
                                width="20px"
                                height="20px"
                                fillColor="none"
                                strokeColor="currentColor"
                            />
                        }
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className={styles.passwordToggleBtn}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                        <IconsColor
                            iconName={showPassword ? "eyeOffIcon" : "eyeIcon"}
                            width="20px"
                            height="20px"
                            fillColor="none"
                            strokeColor="currentColor"
                        />
                    </button>
                </div>

                <Button
                    type="contained"
                    label="Sign In"
                    onClick={() => { }}
                    style={{ height: '48px', width: '100%', marginTop: '8px' }}
                />
            </form>
        </div>
    )
}

export const LoginLeftPartContent = () => {
    return (
        <div className={styles.loginLeftContent}>
            <div className={styles.loginBrand}>
                <img src={logo} alt="Travel Advocates" className={styles.loginLogo} />
            </div>
            <h1 className={styles.loginWelcome}>Welcome to Travel Advocates</h1>
            <p className={styles.loginDescription}>
                Your trusted travel management platform for hotels, packages, and agents
            </p>
        </div>
    )
}